var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.026 4.88A6.526 6.526 0 002.5 11.406c0 3.613 1.445 5.421 7.493 10.126l2.78 2.16a2 2 0 002.455 0l2.779-2.16c6.048-4.705 7.493-6.513 7.493-10.126a6.526 6.526 0 00-6.526-6.526c-1.872 0-3.538.85-4.974 2.487C12.564 5.73 10.898 4.88 9.026 4.88z",
    fill: "#023F80"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMDI2MzIgNC44OEM1LjQyMTkzIDQuODggMi41IDcuODAxOTQgMi41IDExLjQwNjNDMi41IDE1LjAxOTEgMy45NDQ5OCAxNi44Mjc0IDkuOTkzMjMgMjEuNTMxNkwxMi43NzIxIDIzLjY5MjlDMTMuNDk0MyAyNC4yNTQ3IDE0LjUwNTcgMjQuMjU0NyAxNS4yMjc5IDIzLjY5MjlMMTguMDA2OCAyMS41MzE2QzI0LjA1NSAxNi44Mjc0IDI1LjUgMTUuMDE5MSAyNS41IDExLjQwNjNDMjUuNSA3LjgwMTk0IDIyLjU3ODEgNC44OCAxOC45NzM3IDQuODhDMTcuMTAyMiA0Ljg4IDE1LjQzNTkgNS43MzAzNyAxNCA3LjM2NjU1QzEyLjU2NDEgNS43MzAzNyAxMC44OTc4IDQuODggOS4wMjYzMiA0Ljg4WiIgZmlsbD0iIzAyM0Y4MCIvPgo8L3N2Zz4K";
export { SvgLike as ReactComponent };